import cn from 'classnames';
import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Volanta = ({ label, textColor = 'text-cyan-dark', svgColor = '#064246' }) => {
  const root = useRef(null);

  useEffect(() => {
    const volantas = gsap.utils.toArray('.volanta-js');

    volantas.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          x: -20
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'bottom bottom'
            // markers: true
          },
          autoAlpha: 1,
          x: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  return (
    <div ref={root} className="flex items-center | volanta-js">
      <div className="mr-4">
        <svg
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.92029 0.179558C4.246 0.196241 4.55661 0.284418 4.85888 0.402387C5.25171 0.55531 5.62071 0.755102 5.9774 0.977931C6.66217 1.40572 7.29769 1.90103 7.9205 2.41262C8.46825 2.86265 9.01519 3.31308 9.56333 3.76271C9.64793 3.83222 9.73691 3.89656 9.82389 3.96329C9.83819 3.97402 9.8517 3.98594 9.86719 3.99865C9.71466 4.1186 9.56373 4.23339 9.41676 4.35374C8.96197 4.72672 8.50916 5.10247 8.05516 5.47663C7.48517 5.94612 6.90764 6.40568 6.29397 6.81718C5.86221 7.10635 5.41615 7.37049 4.93395 7.5675C4.5157 7.73829 4.08473 7.84673 3.62795 7.8229C3.12271 7.79668 2.63932 7.68308 2.18214 7.46383C1.60739 7.18857 1.12916 6.79613 0.750627 6.28374C0.379244 5.78128 0.145292 5.21964 0.0483751 4.60319C-0.0521169 3.96171 0.00349128 3.33175 0.219569 2.71847C0.455109 2.04958 0.847544 1.48833 1.3937 1.03672C1.8473 0.661758 2.36128 0.405963 2.93484 0.271709C3.25855 0.195844 3.58744 0.162876 3.9191 0.179956L3.92029 0.179558Z"
            fill={svgColor}
          />
        </svg>
      </div>
      <div>
        <p className={cn(textColor, 'c1 uppercase')}>{label}</p>
      </div>
    </div>
  );
};
export default Volanta;
